import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DateRange } from './timeDicerDateRangeSelection.state';

export const getTimeDicerDateRangeSelectionState = createFeatureSelector< DateRange>('timeDicerDateRangeSelection');

export const getTimeDicerDateRange = createSelector(
  getTimeDicerDateRangeSelectionState,
  (state) => state.timeDicerDateRangeSelection
);